// extracted by css-extract-rspack-plugin
export default {"user":"UserMenu__user--MsB5v","email":"UserMenu__email--fLOLX","pulldown":"UserMenu__pulldown--ck6P2"};